// AI Chat — uses the buyer's Groq API key (from Settings) to run the configured agent.
// The PWA works fully without this for designing the agent; the key is needed for live chat.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiChat(
  agentSystemPrompt: string,
  userInput: string,
  onStream: (chunk: string) => void
): Promise<void> {
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: agentSystemPrompt },
        { role: 'user', content: userInput },
      ],
      temperature: 0.3,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The agent designer works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
